<div class="form-control social-icon-control type-dropdown" dropdown>
    <ul class="social-icon-elements type-dropdown-toggle" dropdownToggle>
        <li *ngFor="let name of iconNames">
            <img [src]="getSocialNetworkIconSrc(iconType, name)" [alt]="name" />
        </li>
    </ul>

    <div class="dropdown-menu social-icon-dropdown" *dropdownMenu>
        <ng-container *ngFor="let type of iconTypes">
            <div [class.selected]="iconType === type" (click)="setIconType(type)">
                <ul class="social-icon-elements">
                    <li *ngFor="let name of iconNames">
                        <img [src]="getSocialNetworkIconSrc(type, name)" [alt]="name" />
                    </li>
                </ul>
            </div>
        </ng-container>
    </div>
</div>
